export default __webpack_public_path__ + "static/5ALA-19cd5dd19d8645cdf51574301ec09124.jpg";